<template>
  <a :href="linkUrl" class="ticket--connected_with_link">
    <div class="ticket-box chevron--forward--black">
      <span v-if="isTicketExpired" class="tag">期限切れ</span>
      <span class="ticket-image">
        <ImgLazy
          :image-url="imageUrl"
          :alt-text="itemName"
          aspect-ratio="1"
          width="72"
          height="72"
          class="ticket-image-container"
        />
      </span>
      <div class="ticket-info">
        <p class="ticket__brand--small">
          {{ brandName }}
        </p>
        <p class="ticket__item-name">
          {{ itemName }}
        </p>
        <p v-if="isNotEmptyItemSkuName" class="ticket__item-min-unit">
          {{ itemSkuName }}
        </p>
        <p v-if="isNotEmptyExprirationDate" class="ticket-expired-date">
          {{ expirationDate }}
        </p>
      </div>
    </div>
  </a>
</template>

<script>
import ImgLazy from '../images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemSkuName: {
      type: String,
      required: false,
      default: ''
    },
    brandName: {
      type: String,
      required: true
    },
    isTicketExpired: {
      type: Boolean,
      required: true
    },
    // TODO: ↓名称をexpiredDateに変更する
    expirationDate: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    isNotEmptyItemSkuName() {
      return this.itemSkuName !== ''
    },
    isNotEmptyExprirationDate() {
      return this.expirationDate !== ''
    }
  }
}
</script>
<style lang="scss" scoped>
.ticket {
  &--connected_with_link {
    min-width: 500px;
  }

  &-box {
    height: 88px;
    display: flex;
  }

  &-image {
    height: 100%;
    font-size: 0;
  }

  &-image {
    .ticket-image-container {
      border-radius: 8px;
    }
  }

  &-info {
    overflow: hidden;
    width: 100%;
    padding: 0 28px 0 16px;
    display: flex;
    flex-direction: column;
    text-align: left;
  }

  &__item-name {
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 2px;
    color: $black;
  }

  &__item-min-unit {
    font-weight: bold;
    font-size: 1.2rem;
    line-height: 1.6;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-bottom: 2px;
    color: $black;
  }

  &__brand--small {
    font-size: 1rem;
    line-height: 1.6;
    color: $gray-1;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: bold;
    padding-bottom: 2px;
  }

  &-expired-date {
    font-size: 1rem;
    color: $gray-1;
    padding-top: 0;
    text-align: left;
    right: 0;
    line-height: 1.4;
  }
}
</style>
